<template>
  <v-container fluid class="fancyback pa-0" style="height: inherit;">

    <v-row no-gutters v-if="isPcBool" style="height: inherit;">
      <v-col cols="6" class="pb-4 px-1" style="height: inherit; overflow-y: auto; direction: rtl;">
        <div style="direction: ltr;" class="ml-2">
          <customer-card-list :customer="customer" :isNew="true">
          </customer-card-list>
        </div>
        <div style="direction: ltr;" class="ml-2">
          <job-card :job="JobDetails" :isNew="true">
          </job-card>
        </div>
      </v-col>
      <v-col cols="6" class="pl-2">
        <machine-card-list :machines="machines" :isNew="true">
        </machine-card-list>
      </v-col>
    </v-row>

    <v-row no-gutters v-else class="px-4">
      <v-col cols="12">
        <customer-card-list :customer="customer" :isNew="true">
        </customer-card-list>
      </v-col>
      <v-col cols="12">
        <job-card :job="JobDetails" :isNew="true">
        </job-card>
      </v-col>
      <v-col cols="12">
        <machine-card-list :machines="machines" :isNew="true">
        </machine-card-list>
      </v-col>
    </v-row>

    <overlay-loading :loading="LoadingCreate"></overlay-loading>
  </v-container>
</template>


<script>
import CustomerCardList from "@/views/job/newjob/cards/customer/CustomerCardList2.vue";
import MachineCardList from "@/views/job/newjob/cards/machines/MachineJobCardList.vue";
import JobCard from "@/views/job/newjob/cards/jobdetails/JobCard.vue";
import OverlayLoading from "@/components/Sections/OverlayLoading.vue";

export default {
  name: "NewJobOverview",
  components: { CustomerCardList, MachineCardList, JobCard, OverlayLoading },

  data() {
    return {};
  },

  mounted() {
    this.do();
  },

  methods: {
    async do() {
      if ((this.$route.query && this.$route.query.machineId) || this.$route.query.customerId) {
        this.$store.dispatch("JobHub/clearJob");
        this.$store.dispatch("JobHub/JobSubjobs/clearSubjobs", []);
        if (this.$route.query.machineId) {
          this.$store.dispatch("JobHub/JobPreview/getPreviewMachine", this.$route.query.machineId).then(() => {
            this.$store.dispatch("JobHub/JobPreview/selectPreviewMachine");
          });
        }
        if (this.$route.query.customerId) {
          var id = this.$route.query.customerId;
          this.$store.dispatch("JobHub/JobCustomer/setCustomer", { Id: id });
          this.$store.dispatch("JobHub/JobCustomer/getCustomer", id);
        }
        this.$store.dispatch("JobHub/JobParentjob/setJobDetails", null);
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: Object.assign({}, this.$route.query, { machineId: undefined }),
        });
      }
    },
  },

  computed: {
    customer() {
      return this.$store.getters["JobHub/Customer"];
    },
    machines() {
      return this.$store.getters["JobHub/Subjobs"];
    },
    JobDetails() {
      return this.$store.getters["JobHub/JobDetails"];
    },
    LoadingCreate() {
      return this.$store.getters["JobHub/LoadingCreate"];
    },
  },
};
</script>

<style>
.fancyback {
  background-color: rgb(250, 250, 250);
  position: relative;
}
</style>